import React from 'react';
import { Text } from '@fluentui/react-components';
import { ErrorCircleFilled } from '@fluentui/react-icons';
import { useStyles } from './OnboardingOutcome.styles';

export const OnboardingFailedPage: React.FC = () => {
  const styles = useStyles();

  return (
    <main className={styles.outcomePage} data-testid="onboarding-failed-page">
      <section className={`${styles.outcomeCard} ${styles.failureCard}`} data-testid="onboarding-failed-content">
        <ErrorCircleFilled className={styles.failureIcon} aria-hidden />
        <Text as="h1" className={styles.failureTitle} data-testid="onboarding-failed-title">
          Couldn't enable disclaimers
        </Text>
        <Text as="p" className={styles.failureDescription} data-testid="onboarding-failed-description">
          Try again using the link in your email. If it keeps failing, contact your Microsoft Teams administrator.
        </Text>
      </section>
    </main>
  );
};
